import script from "./PreviewComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewComponent.vue?vue&type=script&setup=true&lang=ts"

import "./PreviewComponent.vue?vue&type=style&index=0&id=dc94c33a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc94c33a"]])

export default __exports__